import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=d98e1d82&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=d98e1d82&lang=less&scoped=true&"
import style1 from "./Comment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98e1d82",
  null
  
)

export default component.exports